$(function () {

    'use strict';

    const options = {
        uuid: window.shareUuid,
        agid: window.agid,
        scid: window.scid,
        loggedIn: window.loggedIn,
        landscapeIsAuditable: window.landscapeIsAuditable,
        landscapeCompanies: window.landscapeCompanies,
        focusCompanyId: window.focusCompanyId,
        maxNewCompanies: window.maxNewCompanies,
        landscapeId: window.landscapeId
    };

    RivalIQ.apps.Shell.execute('show:app', {
        app: RivalIQ.apps.Share,
        options: options
    });

});
